import React from "react";
import TextInputField from "../../../../helpers/TextInputField";
import Table from "../../../../helpers/Table";
import Button from "../../../../helpers/Button";


const IndustryList = () => {
    const tableColumns = [
        {
            header: 'Action',
            field: 'action',
            // body: actionBodyTemplate
        },
        {
            header: 'Name',
            field: 'name',
            sortable: true,
            filter: true,
           
        },
        {
            header: 'Description',
            field: 'description',
            sortable: true,
            // body: statusBodyTemplate
        },
        {
            header: 'Country',
            field: 'countryName',
            sortable: true,
            // body: statusBodyTemplate
        },
        {
            header: 'Create Date',
            field: 'created_at',
            sortable: true,
            // body: statusBodyTemplate
        },
        {
            header: 'Status',
            field: 'status',
            sortable: true,
            // body: statusBodyTemplate
        }
    ]
    return(
        <div className="p-card">
            <div className="">
                <div className="flex justify-content-between flex-wrap">
                    <h3 className="align-items-start">Industry Mangement</h3>
                    <div className="align-items-end">   
                        <Button label="Add New Industry" />
                    </div>
                </div>
                <div className="my-5">
                    <Table  tableColumns={tableColumns}/>
                </div>
            </div>
        </div>
    )
}

export default IndustryList;